<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/zjzk.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/zjzk_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>展会</span><span style="color:#D7230C;">大厅</span></div>
							<div class="sm_pub">带你领略展会风采</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">展会会议</div>
				</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">
				<!-- 左侧内容 -->
				<div class="top_L">
					<div style="width: 100%;height: 300px;padding: 10px;">
						<div v-for="(item,index) in dzh" :key="index"
							style="width: 48%;height: 300px;margin-left: 1%;float: left;border: 1px solid #6e6e6e;">
							<div style="height: 200px;">
								<img v-lazy="item.picture" style="width: 100%;height: 100%;" alt="">
							</div>
							<div style="height: 25px;width: 100%;text-align: center;font-weight: 800;font-size: 20px; overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;">
								{{item.title}}
							</div>
							<div style="height: 30px;width: 100%;text-align: center;font-size: 14px; overflow: hidden;line-height: 30px;
							text-overflow:ellipsis;
							white-space: nowrap;">
								{{item.title}}
							</div>
							<router-link tag="div"
								:to="{ path:'/zhhydetail',query:{id:item.id,title:item.title,mid:'1'} }"
								style="width: 20%;height: 25px;margin: 0 auto;font-size: 18px;color: #D7230C;font-weight: 600;border: 1px solid #D7230C;text-align: center;">
								查看详情
							</router-link>
						</div>
					</div>
					<div style="width: 100%;height: 220px;padding: 10px;">
						<el-carousel indicator-position="none" trigger="click" height="200px">
							<el-carousel-item v-for="(item,index) in 1" :key="index">
								<div style="height: 200px;">
									<router-link tag="div"  class="nimabi"
										:to="{ path:'/zhhydetail',query:{id:o.id,title:o.title,mid:'2'} }"
										style="width: 31.5%;height: 200px;float: left;margin-left: 1%;position: relative;"
										v-for="(o,index) in xhy[index]" :key="index">
										<div style="height: 200px;">
											<img style="width: 100%;height: 100%;" v-lazy="o.picture" alt="">
										</div>
										<div style="opacity:0.5;text-align: center;background: rgba(0, 0, 0, 0.6);color: #FFF;height: 40px;line-height: 40px;position: absolute;bottom: 0px;width: 100%;">
											{{o.title}}
										</div>
									</router-link>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<!-- 日期 -->
					<div class="wtyname">
						<div style="width: 49%;height: 450px;float: left;">
							<div style="height: 90px;">
								<div @click="qwqs('2020-01','2')"
									style="width: 30%;height: 85px;background: #000;float: left;margin-left: 2.5%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
									1月
								</div>
								<div @click="qwqs('2020-02','2')"
									style="width: 30%;height: 85px;background: #000;float: left;margin-left: 3%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
									2月
								</div>
								<div @click="qwqs('2020-03','2')"
									style="width: 30%;height: 85px;background: #000;float: left;margin-left: 3%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
									3月
								</div>
							</div>
							<div style="height: 270px;">
								<div style="width: 30%;height: 265px;float: left;margin-left: 2.5%;margin-top: 5px;">
									<div @click="qwqs('2020-12','2')"
										style="width: 100%;height: 85px;background: #000;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
										12月
									</div>
									<div @click="qwqs('2020-11','2')"
										style="width: 100%;height: 85px;background: #000;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
										11月
									</div>
									<div @click="qwqs('2020-10','2')"
										style="width: 100%;height: 85px;background: #000;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
										10月
									</div>
								</div>
								<div @click="zhfba"
									style="width: 30%;height: 265px;background: #000;float: left;margin-left: 3%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 265px;text-align: center;">
									展会发布
								</div>
								<div style="width: 30%;height: 265px;float: left;margin-left: 3%;margin-top: 5px;">
									<div @click="qwqs('2020-04','2')"
										style="width: 100%;height: 85px;background: #000;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
										4月
									</div>
									<div @click="qwqs('2020-05','2')"
										style="width: 100%;height: 85px;background: #000;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
										5月
									</div>
									<div @click="qwqs('2020-06','2')"
										style="width: 100%;height: 85px;background: #000;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
										6月
									</div>
								</div>
							</div>
							<div style="height: 90px;">
								<div @click="qwqs('2020-09','2')"
									style="width: 30%;height: 85px;background: #000;float: left;margin-left: 2.5%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
									9月
								</div>
								<div @click="qwqs('2020-08','2')"
									style="width: 30%;height: 85px;background: #000;float: left;margin-left: 3%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
									8月
								</div>
								<div @click="qwqs('2020-07','2')"
									style="width: 30%;height: 85px;background: #000;float: left;margin-left: 3%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
									7月
								</div>
							</div>
						</div>
						<div style="width: 49%;height: 450px;float: left;margin-left: 1%;">
							<div style="height: 90px;">
								<div @click="qwqs('2020-01','1')"
									style="width: 30%;height: 85px;background: #000;float: left;margin-left: 2.5%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
									1月
								</div>
								<div @click="qwqs('2020-02','1')"
									style="width: 30%;height: 85px;background: #000;float: left;margin-left: 3%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
									2月
								</div>
								<div @click="qwqs('2020-03','1')"
									style="width: 30%;height: 85px;background: #000;float: left;margin-left: 3%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
									3月
								</div>
							</div>
							<div style="height: 270px;">
								<div style="width: 30%;height: 265px;float: left;margin-left: 2.5%;margin-top: 5px;">
									<div @click="qwqs('2020-12','1')"
										style="width: 100%;height: 85px;background: #000;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
										12月
									</div>
									<div @click="qwqs('2020-11','1')"
										style="width: 100%;height: 85px;background: #000;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
										11月
									</div>
									<div @click="qwqs('2020-10','1')"
										style="width: 100%;height: 85px;background: #000;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
										10月
									</div>
								</div>
								<div @click="zhfba"
									style="width: 30%;height: 265px;background: #000;float: left;margin-left: 3%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 265px;text-align: center;">
									会议发布
								</div>
								<div style="width: 30%;height: 265px;float: left;margin-left: 3%;margin-top: 5px;">
									<div @click="qwqs('2020-04','1')"
										style="width: 100%;height: 85px;background: #000;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
										4月
									</div>
									<div @click="qwqs('2020-05','1')"
										style="width: 100%;height: 85px;background: #000;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
										5月
									</div>
									<div @click="qwqs('2020-06','1')"
										style="width: 100%;height: 85px;background: #000;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
										6月
									</div>
								</div>
							</div>
							<div style="height: 90px;">
								<div @click="qwqs('2020-09','1')"
									style="width: 30%;height: 85px;background: #000;float: left;margin-left: 2.5%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
									9月
								</div>
								<div @click="qwqs('2020-08','1')"
									style="width: 30%;height: 85px;background: #000;float: left;margin-left: 3%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
									8月
								</div>
								<div @click="qwqs('2020-07','1')"
									style="width: 30%;height: 85px;background: #000;float: left;margin-left: 3%;margin-top: 5px;opacity: 0.6;color: #FFF;font-size: 24px;font-weight: 800;cursor: pointer;line-height: 85px;text-align: center;">
									7月
								</div>
							</div>
						</div>
					</div>
					
					<div style="width: 100%;border-bottom: 1px solid red;box-sizing: border-box;">
						<div class="pub_title" style="float: none;">
							<div class="title_t">
								<div class="sm_t">
									<div style="float:left"><span>优质</span><span style="color:#D7230C;">供应商</span></div>
								</div>
							</div>
						</div>
					</div>
					
					<div style="width: 100%;height: 220px;padding: 10px;">
						<el-carousel indicator-position="none" trigger="click" height="200px">
							<el-carousel-item v-for="(item,index) in 1" :key="index">
								<div style="height: 200px;">
									<router-link tag="div" class="nimabi"
										:to="{path: '/qydqdetail', query: {id:o.id,title:o.title}}"
										style="width: 31.5%;height: 200px;float: left;margin-left: 1%;position: relative;"
										v-for="(o,index) in gongying" :key="index">
										<div style="height: 200px;">
											<img style="width: 100%;height: 100%;" v-lazy="o.logo" alt="">
										</div>
										<div style="opacity:0.5;text-align: center;background: rgba(0, 0, 0, 0.6);color: #FFF;height: 40px;line-height: 40px;position: absolute;bottom: 0px;width: 100%;">
											{{o.title}}
										</div>
									</router-link>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
				
				
				
				<!-- 右边部分 -->
				<div style="width: 20%;height: 800px;float: left;margin-top: 10px;">
					<div class="jrsp_list">
						<div class="title_">会议播报</div>
						<ul class='zh_right'>
							<router-link tag="li" class="pub_list_q" v-for="(item,index) in lefta" :key="index"
								:to="{ path:'/zhhydetail',query:{id:item.id,title:item.title,mid:'1'} }">
								<div class="title" style="width: 90%;">{{item.title}}</div>
							</router-link>
						</ul>
					</div>
					<div class="jrsp_list">
						<div class="title_">展会播报</div>
						<ul class='zh_right'>
							<router-link tag="li" class="pub_list_q" v-for="(item,index) in leftb" :key="index"
								:to="{ path:'/zhhydetail',query:{id:item.id,title:item.title,mid:'2'} }">
								<div class="title" style="width: 90%;">{{item.title}}</div>
							</router-link>
						</ul>

					</div>
				</div>
			</div>


		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				dzh: '',
				xhy: '',
				lefta: [],
				leftb: [],
				gongying:[],
				
			}
		},
		methods: {
			zhfba() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('token') || null)
				if (loginInfo == null) {
					this.$router.push({
						path: '/login'
					})
				} else {
					this.$router.push({
						path: '/user'
					})
				}
			},
			qwqs(val, vals) {
				this.$router.push({
					path: 'zhhyerji',
					query: {
						id: val,
						mid: vals
					}
				})
			},
		},
		async mounted() {
			let res = await http.get('api/picture/meettow')
			this.dzh = res.data.data.zhanhui
			var xhys = res.data.data.meet.length
			this.xhy = Math.ceil(xhys / 3)
			let newArrs = [
				[],
				[],
				[],
				[],
				[],
				[],
				[],
				[],
				[],
				[],
				[],
				[]
			]
			res.data.data.meet.forEach((item, index) => {
				if (index < 3) {
					newArrs[0].push(item)
				} else if (index >= 3 && index < 6) {
					newArrs[1].push(item)
				} else if (index >= 6 && index < 9) {
					newArrs[2].push(item)
				} else if (index >= 12 && index < 16) {
					newArrs[3].push(item)
				} else if (index >= 20 && index < 25) {
					newArrs[4].push(item)
				} else if (index >= 25 && index < 30) {
					newArrs[5].push(item)
				} else if (index >= 30 && index < 35) {
					newArrs[6].push(item)
				} else if (index >= 35 && index < 40) {
					newArrs[7].push(item)
				} else if (index >= 40 && index < 45) {
					newArrs[8].push(item)
				} else if (index >= 45 && index < 50) {
					newArrs[9].push(item)
				}
			})
			this.xhy = newArrs

			let res1 = await http.post('api/Common/index', {
				model: 'meet',
				type: 'content',
				mid: '4',
				rows_limit: '7'
			})
			this.lefta = res1.data.data.list.data

			let res2 = await http.post('api/Common/index', {
				model: 'meet',
				type: 'content',
				mid: '5',
				rows_limit: '7'
			})
			this.leftb = res2.data.data.list.data
			
			let res6 = await http.post('api/Common/index',{
				model:'qydb',
				type:'content',
				mid:'4',
				fid:'366'
			})
			console.log(res6)
			this.gongying = res6.data.data.list.data.slice(0,3)
			
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),

		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		height: 1350px;
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}

	.Bigcosousuo {
		float: left;
		width: 300px;
		height: 36px;
		border: 1px solid #ececec;
		margin-left: 50px;
		background-color: #D7230C;
	}

	.Bigcosousuo>input {
		width: 65%;
		height: 34px;
		float: left;
		border: 0px;
		outline: none;
	}

	.Bigcosousuo>div {
		width: 30%;
		height: 36px;
		float: left;
		line-height: 36px;
		font-size: 20px;
		color: #FFF;
		font-weight: 800;
		text-align: center;
	}

	.rwdt_fb_0 {
		float: left;
		font-size: 17px;
		width: 110px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		margin-left: 50px;
		border: 1px solid #e82904;
		color: #e82904;
		border-radius: 4px;
		cursor: pointer;
	}

	/* 头部结束 */
	.top_bottom {
		width: 100%;
		height: 1300px;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}

	.top_L {
		float: left;
		width: 80%;
		height: 1300px;
	}

	.wtyname {
		width: 98%;
		height: 455px;
		margin-left: 2%;
		background-image: url(../../../imges/zhaaa.png);
		background-size: 100% 100%;
	}

	.pub_list_q {
		font-size: 14px;
		margin: 6px 0;
	}

	.jrsp_list {
		width: 100%;
		float: right;
	}

	.title_ {
		height: 42px;
		background-color: #E82904;
		color: #fff;
		font-size: 16px;
		line-height: 42px;
		padding-left: 18px;
		letter-spacing: 3px;
	}

	.zh_right {
		border: 1px solid #ddd;
		border-top: none;
		padding-top: 10px;
		padding-bottom: 10px;
		padding: 0px;
		margin: 0px;
	}



	.zh_right>li {
		padding: 8px 0;
		list-style: none;
		height: 25px;
	}

	.title {
		float: left;
		width: 68%;
		padding-left: 6px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		cursor: pointer;
	}
	
	.nimabi:hover{
		box-shadow: 5px 15px 15px #333;
	}
</style>
